import Vue from 'vue'
import {get} from 'lodash'
import {CancelToken} from 'axios'
import {http} from '@/axios'
import handleError from '@/helpers/handleError'

let cancel;

function getState() {
  return {
    pending: false,
    pendingSave: false,
    pendingEvergreen: false,
    errorEvergreen: false,
    error: null,
    receivedData: null,
    inputs: {
      first_name: {
        value: null
      },
      second_name: {
        value: null
      },
      country: {
        value: null,
        passportRequired: true
      },
      date_of_birth: {
        value: null,
        passportRequired: true
      },
      expiration_date: {
        value: null,
        passportRequired: true
      },
      date_of_issue: {
        value: null,
        passportRequired: true
      },
      mrz: {
        value: null,
        passportRequired: false
      },
      mrz_type: {
        value: null,
        passportRequired: false
      },
      number: {
        value: null,
        passportRequired: true
      },
      authority: {
        value: null,
        passportRequired: true
      },
      nationality: {
        value: null,
        passportRequired: true
      },
      names: {
        value: null,
        passportRequired: true
      },
      surname: {
        value: null,
        passportRequired: true
      },
      sex: {
        value: null,
        passportRequired: true
      },
    },
    photo: null,
    newPhoto: null,

    passport: null
  }
}

export default {
  namespaced: true,
  state: getState(),
  getters: {
    canSetPassportStatus(state) {
      const receivedData = state.receivedData
      const inputs = state.inputs

      for (const key in inputs) {
        const input = inputs[key]
        if (input.passportRequired && !receivedData[key]) {
          return false
        }
      }

      return true
    },
    // isAllPassportsApproved
  },
  mutations: {
    resetState(state) {
      Object.assign(state, getState())
    },
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return

      Vue.set(state, key, value)
    },
    setInput(state, [key, value]) {
      if (!state.inputs.hasOwnProperty(key)) return

      Vue.set(state.inputs[key], 'value', value)
    },
    setInputErrors(state, errors) {
      const inputs = state.inputs

      for (const key in inputs) {
        Vue.set(inputs[key], 'error', errors ? errors[key] : null)
      }
    },
    parseReceivedData(state, data) {
      const inputs = state.inputs

      for (const key in inputs) {
        Vue.set(inputs[key], 'value', data[key] || null)
      }

      state.photo = createImgObjFromLink(data.photo)
      state.newPhoto = null
      state.receivedData = data || null
      state.passport = get(data, 'questionaire_data.passport[0].items', null)
    },
    setPassportStatus(state, {index, status}) {
      Vue.set(state.passport[index], 'passport_page_status', status || null)
    },
    setPassportPending(state, {index, value}) {
      Vue.set(state.passport[index], 'pending', value)
    }
  },
  actions: {
    addPhoto({commit}, file) {
      if (!file) {
        return commit('setProperty', ['newPhoto', null])
      }

      const photo = {
        newFile: true,
        file,
        type: file.type,
        name: file.name,
        path: window.URL.createObjectURL(file)
      }

      commit('setProperty', ['newPhoto', photo])
    },
    deletePhoto({commit}) {
      commit('setProperty', ['newPhoto', null])
    },
    load({commit}, id) {
      if (cancel) {
        cancel();
      }
      commit('resetState')
      commit('setProperty', ['pending', true])

      return http.get(`/api/backoffice/resumes/${id}`, {
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c;
        })
      })
        .then(({data}) => {
          commit('parseReceivedData', data.resume)
        })
        .catch(e => {
          commit('setProperty', ['error', handleError(e)])
        })
        .finally(() => {
          commit('setProperty', ['pending', false])
        })
    },
    send({state, commit}, id) {
      const formData = new FormData()
      const inputs = state.inputs
      const newPhoto = state.newPhoto

      for (const key in inputs) {
        formData.append(key, inputs[key].value || '')
      }

      if (newPhoto) {
        formData.append('photo', newPhoto.file)
      }

      commit('setProperty', ['pendingSave', true])

      return http.post(`api/backoffice/resumes/${id}/update`, formData)
        .then(({data}) => {
          commit('parseReceivedData', data.resume)

          return data.resume
        })
        .catch(e => {
          const inputErrors = get(e, 'response.data.errors')

          commit('setProperty', ['error', handleError(e)])
          commit('setInputErrors', inputErrors)
        })
        .finally(() => {
          commit('setProperty', ['pendingSave', false])
        })
    },

    getEvergreen({commit}, id) {
      commit('setProperty', ['pendingEvergreen', true])

      return http.post(`/api/backoffice/resumes/${id}/evergreen`)
        .then(({data}) => {
          commit('parseReceivedData', data.resume)

          return data.resume
        })
        .catch(e => {
          commit('setProperty', ['errorEvergreen', handleError(e)])
        })
        .finally(() => {
          commit('setProperty', ['pendingEvergreen', false])
        })
    },

    rejectPassportPage({state, commit}, {reason, index}) {
      const currentPage = state.passport[index]

      commit('setPassportPending', {
        value: true,
        index
      })

      http.post('/api/backoffice/resumes/passport/status', {
        action: 'rejected',
        reject_reason: reason,
        passport_page_id: currentPage.passport_page.section_id
      })
        .then(({data}) => {
          // commit('setPassportStatus', {
          //   status: get(data, 'status.original.data'),
          //   index
          // })

          commit('parseReceivedData', get(data, 'status.original.data'))
        })
        .finally(() => {
          commit('setPassportPending', {
            value: false,
            index
          })
        })
    },
    approvePassportPage({state, commit}, {index}) {
      const currentPage = state.passport[index]

      commit('setPassportPending', {
        value: true,
        index
      })

      http.post('/api/backoffice/resumes/passport/status', {
        action: 'approved',
        passport_page_id: currentPage.passport_page.section_id
      })
        .then(({data}) => {
          commit('parseReceivedData', get(data, 'status.original.data'))
        })
        .finally(() => {
          commit('setPassportPending', {
            value: false,
            index
          })
        })
    },
    cancelStatusPassportPage({state, commit}, {index}) {
      const currentPage = state.passport[index]

      commit('setPassportPending', {
        value: true,
        index
      })

      http.post('/api/backoffice/resumes/passport/status', {
        action: 'reject_status',
        passport_page_id: currentPage.passport_page.section_id
      })
        .then(({data}) => {
          commit('parseReceivedData', get(data, 'status.original.data'))
        })
        .finally(() => {
          commit('setPassportPending', {
            value: false,
            index
          })
        })
    }
  }
}


function createImgObjFromLink(link) {
  if(!link) return null

  let ext = (/[.]/.exec(link)) ? /[^.]+$/.exec(link) : undefined;

  return {
    ext: ext && ext[0] || 'jpg',
    path: link
  }
}
